module.exports = __webpack_public_path__ + "static/img/project_person3.5b24342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project_person3.png
// module id = MqPd
// module chunks = 1